import LegacyKyc from '../../../banking/components/kyc-legacy/Kyc';

const LegacyKycPage = () => {
    return <LegacyKyc />;
};

export default LegacyKycPage;
